// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"977":"30106a6d","3941":"b2b4252d","4068":"887b921a","5545":"c218f736","5640":"8c79f9c0","5925":"96e60b34"}[chunkId] + ".chunk.css";
};